import * as React from "react";
var SvgIconSmall = function SvgIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", props);
};
export default SvgIconSmall;